/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-private-classes */
/* eslint-disable promise/catch-or-return */

import userInfo from 'hub-http/userInfo';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIButton from 'UIComponents/button/UIButton';
import UIFileButton from 'UIComponents/button/UIFileButton';
import { callIfPossible } from 'UIComponents/core/Functions';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { uploadFile } from '../api/FileManagerApi';
import SmallToggleButton from './SmallToggleButton';
import { IMAGE_ATOMIC_TYPE, IMAGE_BLOCK_TYPE, HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE } from '../utils/constants';
import { getSignedSrc } from '../utils/Images';
import { getImageDimensions } from '../utils/libUtils';
import * as PMImageActionTypes from '../utils/prosemirrorImageActionTypes';
import { Tracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INSERT_IMAGE = 'insert-image';
export default function createImageButton({
  FileManager,
  FilePickerPanel,
  onOpenPopover = () => {},
  tooltipPlacement = 'bottom',
  httpClient,
  SharedDragDropContext,
  useOptionsPopover = false,
  shouldScaleInserts = false,
  uploadImage = uploadFile,
  getSignedImageSrc = getSignedSrc,
  getUserInfo = () => userInfo(),
  fileUploadAccess = HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE
} = {}) {
  const tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "draftPlugins.imagePlugin.tooltip"
  });
  const scaleImageSize = rawImageData => {
    if (!shouldScaleInserts) {
      return rawImageData;
    }
    if (rawImageData.width) {
      const scale = rawImageData.width < 400 ? 1 : 400 / rawImageData.width;
      return Object.assign({}, rawImageData, {
        width: rawImageData.width * scale,
        height: rawImageData.height ? rawImageData.height * scale : undefined
      });
    } else {
      return Object.assign({}, rawImageData, {
        width: 400,
        // height should default to auto, if an image doesn't have width it shouldnt have height
        height: undefined
      });
    }
  };
  class ImageButton extends Component {
    constructor(props) {
      super(props);
      this.onCloseComplete = () => {
        this.props.onPluginCloseModal();
      };
      this.handleSetPickerStateToClosed = () => {
        this.setState({
          pickerOpen: false
        });
      };
      this.handleLocalFileUpload = evt => {
        evt.stopPropagation();
        this.setState({
          popoverOpen: false
        });
        // UIFileButton `multiple` prop set to `false`, so only ever one image
        const image = evt.target.files[0];
        this.fileReader.readAsDataURL(image);
        this.setState({
          fileToUpload: image
        });
      };
      this.handlePopoverOpenChange = evt => {
        this.setState({
          popoverOpen: evt.target.value
        });
      };
      this.state = {
        auth: null,
        fileToUpload: null,
        pickerOpen: false,
        popoverOpen: false
      };
      this.getIsActive = this.getIsActive.bind(this);
      this.handleInsertImage = this.handleInsertImage.bind(this);
      this.handlePickerClose = this.handlePickerClose.bind(this);
      this.handlePickerOpen = this.handlePickerOpen.bind(this);
    }
    componentDidMount() {
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'auth' implicitly has an 'any' type.
      getUserInfo().then(auth => this.setState({
        auth
      }));
      this.fileReader = new FileReader();
      this.fileReader.addEventListener('load', () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
        const {
          onChange,
          useProsemirror
        } = this.props;
        const tempFileUrl = this.fileReader.result;
        getImageDimensions(tempFileUrl).then(({
          height,
          width
        }) => {
          const rawData = {
            height,
            isTemporary: true,
            src: tempFileUrl,
            uploadPercent: 10,
            width,
            originalDimensions: {
              width,
              height
            },
            fileToUpload: this.state.fileToUpload,
            fileManagerAccess: fileUploadAccess
          };
          const scaledRawData = scaleImageSize(rawData);
          if (useProsemirror) {
            onChange({
              actionType: PMImageActionTypes.LOAD_IMAGE,
              data: Object.assign({}, scaledRawData, {
                originalDimensions: {
                  width,
                  height
                }
              })
            });
          }
          // TODO: remove this since insertion of the image is handled by ImageView -> useImageUploadHandler
          //   - audit usage of createImageButton to confirm that this always duplicates the upload, OR
          //   - create a new createImageButtonV2
          this.uploadImageToFileManager(tempFileUrl);
        }).catch(() => {
          console.warn('Failed to get image dimensions');
        });
      });
    }
    getUploadProgressHandler() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
      const {
        onChange,
        useProsemirror
      } = this.props;
      return progress => {
        if (!progress.lengthComputable) {
          return;
        }
        const percentComplete =
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        parseInt(progress.loaded / progress.total, 10) * 100;
        if (useProsemirror) {
          onChange({
            actionType: PMImageActionTypes.UPLOAD_PROGRESS,
            data: percentComplete
          });
        }
      };
    }
    uploadImageToFileManager(url) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
      const {
        onChange,
        useProsemirror
      } = this.props;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fileToUpload' does not exist on type 'Re... Remove this comment to see the full error message
      const {
        fileToUpload
      } = this.state;
      if (!fileToUpload) {
        return;
      }
      uploadImage(fileToUpload, {
        access: fileUploadAccess,
        onProgress: this.getUploadProgressHandler()
      })
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
      .then(data => {
        const {
          id,
          size
        } = data.objects[0];
        const signedUrl = getSignedImageSrc(id);
        const uploadData = {
          fileManagerId: id,
          isTemporary: false,
          src: signedUrl,
          size,
          uploadPercent: 100,
          tempUrl: url
        };
        if (useProsemirror) {
          onChange({
            actionType: PMImageActionTypes.UPLOAD_COMPLETE,
            data: uploadData
          });
        }
      }).catch(() => {
        if (useProsemirror) {
          onChange({
            actionType: PMImageActionTypes.UPLOAD_FAILED,
            data: {
              tempUrl: url
            }
          });
        }
        const fileName = fileToUpload.name || I18n.text('draftPlugins.imagePlugin.genericFileName');
        FloatingAlertStore.addAlert({
          type: 'danger',
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.imagePlugin.uploadFailedBody",
            options: {
              fileName
            }
          }),
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.imagePlugin.uploadFailedTitle"
          })
        });
      });
    }
    getIsActive() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
      const {
        editorState,
        useProsemirror
      } = this.props;
      if (useProsemirror) {
        return false;
      }
      const selectedBlockKey = editorState.getSelection().getStartKey();
      const selectedBlock = editorState.getCurrentContent().getBlockForKey(selectedBlockKey);
      if (!selectedBlock) {
        return false;
      }
      const type = selectedBlock.getType();
      return type === IMAGE_BLOCK_TYPE && selectedBlock.getData().get('atomicType') === IMAGE_ATOMIC_TYPE;
    }
    handleInsertImage(imgData) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
      const {
        onChange,
        useProsemirror
      } = this.props;
      // the `file-manager-components` iframed file picker returns plain objects instead of immutable Maps
      if (typeof imgData.toJS === 'function') {
        imgData = imgData.toJS();
      }
      const src = imgData.url;
      if (!src) {
        return;
      }
      const rawData = {
        src
      };
      const scaledData = scaleImageSize(rawData);
      Tracker.track('pmImage', {
        action: INSERT_IMAGE,
        method: 'toolbar'
      });
      if (useProsemirror) {
        onChange({
          actionType: PMImageActionTypes.INSERT_IMAGE,
          data: scaledData
        });
      }
      this.setState({
        popoverOpen: false
      });
      this.handlePickerClose();
    }
    handlePickerClose() {
      this.setState({
        pickerOpen: false
      });
    }
    handlePickerOpen() {
      callIfPossible(onOpenPopover);
      this.setState({
        pickerOpen: true
      });
      this.props.onPluginOpenModal();
    }
    renderFileManagerAndPicker() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'auth' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const {
        auth
      } = this.state;
      return /*#__PURE__*/_jsx(FileManager, {
        auth: auth,
        children: /*#__PURE__*/_jsx(FilePickerPanel, {
          disableUpload: useOptionsPopover,
          onClose: this.handlePickerClose,
          onSelect: this.handleInsertImage
          // Aligns with DrawerType from file-manager-components
          // https://git.hubteam.com/HubSpot/FileManagerUI/blob/f213c6f3410e52180861bb4228808c33149040e0/file-manager-components/static-1.8987/js/constants/index.ts#L2
          ,
          type: "IMAGE"
        })
      });
    }
    renderFileManagerOnly() {
      return /*#__PURE__*/_jsx(FileManager, {
        auth: this.state.auth,
        httpClient: httpClient,
        SharedDragDropContext: SharedDragDropContext,
        type: "IMAGE",
        onClose: this.handleSetPickerStateToClosed,
        onSelect: this.handleInsertImage,
        onCloseComplete: this.onCloseComplete
      });
    }
    renderFileManager() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'auth' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const {
        auth,
        pickerOpen
      } = this.state;
      if (!(auth && pickerOpen)) {
        return null;
      }
      if (FileManager && FilePickerPanel) {
        return this.renderFileManagerAndPicker();
      }
      if (FileManager) {
        return this.renderFileManagerOnly();
      }
      return null;
    }
    renderOptions() {
      return /*#__PURE__*/_jsxs(UIList, {
        className: "private-dropdown--list",
        children: [FileManager ? /*#__PURE__*/_jsx(UIButton, {
          onClick: this.handlePickerOpen,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.imagePlugin.existing"
          })
        }) : null, /*#__PURE__*/_jsx(UIFileButton, {
          "data-test-id": "image-file-input",
          accept: ['image/*'],
          onChange: this.handleLocalFileUpload,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.imagePlugin.upload"
          })
        })]
      });
    }
    render() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'popoverOpen' does not exist on type 'Rea... Remove this comment to see the full error message
      const {
        popoverOpen
      } = this.state;
      const sharedButtonProps = {
        active: popoverOpen || this.getIsActive(),
        icon: 'insertImage',
        tooltip,
        tooltipPlacement
      };
      if (useOptionsPopover) {
        return /*#__PURE__*/_jsx(UIPopover, {
          closeOnOutsideClick: true,
          content: this.renderOptions(),
          onOpenChange: this.handlePopoverOpenChange,
          open: popoverOpen,
          children: /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(SmallToggleButton, Object.assign({}, sharedButtonProps, {
              "data-test-id": "image-upload-toggle"
              // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
              ,
              onClick: () =>
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'popoverOpen' does not exist on type 'Rea... Remove this comment to see the full error message
              this.setState(({
                popoverOpen: currentlyOpen
              }) => ({
                popoverOpen: !currentlyOpen
              }))
            })), this.renderFileManager()]
          })
        });
      }
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(SmallToggleButton, Object.assign({}, sharedButtonProps, {
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          onClick: this.handlePickerOpen
        })), this.renderFileManager()]
      });
    }
  }
  ImageButton.propTypes = {
    editorState: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onPluginOpenModal: PropTypes.func,
    onPluginCloseModal: PropTypes.func,
    useProsemirror: PropTypes.bool
  };
  ImageButton.defaultProps = {
    onPluginOpenModal: emptyFunction,
    onPluginCloseModal: emptyFunction,
    useProsemirror: false
  };
  return ImageButton;
}